module.exports = __webpack_public_path__ + "static/media/beauty4.7bd4db87.png";